import { connect } from 'react-redux';
import Summary from './Summary';
import timeDepositActions from '../../../../../store/actions/timeDeposit.action';
import googleAnalytics from '../../../../../store/actions/googleAnalytics.action';

const mapStateToProps = state => ({
  step: state.simulation.step,
  newTimeDeposit: state.simulation.newTimeDeposit,
  email: state.user.email,
  rating: state.simulation.rating
});

const mapDispatchToProps = dispatch => {
  return {
    cleanSimulation: () => {
      dispatch(timeDepositActions.cleanSimulation());
    },
    googleAnalytics: (params) => {
      googleAnalytics.registerGoogleAnalytics(params);
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Summary);
